export const withdrawsCards = {
	withdrawCardLabel: "Valor contabilizado em saques realizados no período",
	advanceCardLabel: "Valor contabilizado em antecipações realizadas no período",
	totalLabel: "Soma dos saques e antecipações realizados no período",
};
